
import { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Menu, X, ChevronLeft } from "lucide-react";
import { Link, useLocation } from "wouter";
import img1 from '../../public/lovable-uploads/b8b2c5ca-228d-403f-a6f2-1c3e5bf074c4.png'
import img2 from '../../public/lovable-uploads/794bcc8e-4338-4129-9bd7-38e76b939a38.png'

export default function HeaderAr() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [location] = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const getEnglishPath = () => {
    const currentPath = location;
    if (currentPath === '/ar') return '/';
    return currentPath.replace('/ar', '');
  };

  return (
    <header 
      className={`fixed w-full backdrop-blur-md z-50 transition-all duration-500 ease-apple ${
        scrolled 
          ? 'bg-white/95 shadow-md border-b border-gray-200' 
          : 'bg-transparent'
      }`}
      dir="rtl"
    >
      <div className="editorial-container">
        <div className="flex items-center justify-between py-2 md:py-3">
          <Link to="/ar" className="flex items-center">
            <img 
              src={scrolled 
                ? img1 
                : img2} 
              alt="شعار أمة الموسيقى" 
              className={`w-auto transition-all duration-300 ${
                scrolled ? "h-16" : "h-20" /* Enlarged from original sizes */
              }`}
            />
          </Link>
          
          <div className="hidden md:flex items-center space-x-6 space-x-reverse">
            <nav className="flex space-x-5 space-x-reverse">
              <Link 
                to="/ar/creators" 
                className={`transition-colors duration-300 font-medium text-sm hover-underline font-sans ${
                  scrolled ? 'text-musicBlack' : 'text-musicWhite'
                }`}
              >
                للمبدعين
              </Link>
              <Link 
                to="/ar/businesses" 
                className={`transition-colors duration-300 font-medium text-sm hover-underline font-sans ${
                  scrolled ? 'text-musicBlack' : 'text-musicWhite'
                }`}
              >
                للشركات
              </Link>
              <Link 
                to="/ar/newsroom" 
                className={`transition-colors duration-300 font-medium text-sm hover-underline font-sans ${
                  scrolled ? 'text-musicBlack' : 'text-musicWhite'
                }`}
              >
                غرفة الأخبار
              </Link>
              <Link 
                to="/ar/contact" 
                className={`transition-colors duration-300 font-medium text-sm hover-underline font-sans ${
                  scrolled ? 'text-musicBlack' : 'text-musicWhite'
                }`}
              >
                اتصل بنا
              </Link>
            </nav>
            
            <div className="flex items-center space-x-2 space-x-reverse">
              <Button className="cta-button text-sm py-2 px-4 group" size="sm">
                <span className="relative z-10 flex items-center font-sans">
                  اطلب الحقوق
                  <ChevronLeft className="mr-1 transition-transform duration-300 group-hover:-translate-x-1" size={14} />
                </span>
              </Button>
              <span className={`${scrolled ? 'text-musicBlack/50' : 'text-musicWhite/50'}`}>|</span>
              <Link 
                to={getEnglishPath()}
                className={`transition-colors duration-300 text-sm font-sans ${
                  scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
                }`}
              >
                عربي | EN
              </Link>
            </div>
          </div>
          
          <button 
            className={`md:hidden transition-colors duration-300 ${
              scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      {/* Mobile navigation */}
      <div 
        className={`md:hidden ${scrolled ? 'bg-white' : 'bg-musicBlack'} border-t ${
          scrolled ? 'border-gray-200' : 'border-musicGrey/20'
        } overflow-hidden transition-all duration-500 ease-apple ${
          isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
        }`}
        dir="rtl"
      >
        <div className="editorial-container py-4">
          <nav className="flex flex-col space-y-4">
            <Link 
              to="/ar/creators" 
              className={`transition-colors duration-300 font-medium py-2 font-sans ${
                scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
              }`}
              onClick={() => setIsOpen(false)}
            >
              للمبدعين
            </Link>
            <Link 
              to="/ar/businesses" 
              className={`transition-colors duration-300 font-medium py-2 font-sans ${
                scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
              }`}
              onClick={() => setIsOpen(false)}
            >
              للشركات
            </Link>
            <Link 
              to="/ar/newsroom" 
              className={`transition-colors duration-300 font-medium py-2 font-sans ${
                scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
              }`}
              onClick={() => setIsOpen(false)}
            >
              غرفة الأخبار
            </Link>
            <Link 
              to="/ar/contact" 
              className={`transition-colors duration-300 font-medium py-2 font-sans ${
                scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
              }`}
              onClick={() => setIsOpen(false)}
            >
              اتصل بنا
            </Link>
            <div className="flex flex-col space-y-3 pt-3 border-t border-musicGrey/20">
              <Button className="cta-button w-full justify-center group" size="sm">
                <span className="relative z-10 flex items-center font-sans">
                  اطلب الحقوق
                  <ChevronLeft className="mr-1 transition-transform duration-300 group-hover:-translate-x-1" size={14} />
                </span>
              </Button>
              <Button variant="outline" className="secondary-button w-full justify-center group" size="sm">
                <span className="relative z-10 flex items-center font-sans">
                  أبلغ عن الاستخدام
                  <ChevronLeft className="mr-1 transition-transform duration-300 group-hover:-translate-x-1" size={14} />
                </span>
              </Button>
              <Button variant="ghost" className={`w-full justify-center font-sans ${
                scrolled ? 'text-musicBlack' : 'text-musicWhite'
              }`}>تسجيل الدخول</Button>
            </div>
            <div className="flex justify-center pt-3">
              <Link 
                to={getEnglishPath()}
                className={`transition-colors duration-300 font-sans ${
                  scrolled ? 'text-musicBlack hover:text-musicRed' : 'text-musicWhite hover:text-musicRed'
                }`}
              >
                عربي | EN
              </Link>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
